import { v4 as uuidv4 } from "uuid";
import { callApi } from "modules/core/api/services";
import { ApiResponse } from "modules/core/api/types";
import { Page } from "types/interfaces/Page";

interface ClippingBody {
  source: string;
  start: number;
  duration: number;
  output: string;
  uuid: string;
}

const getToken = async () => {
  const body = {
    apiUser: "mam",
    apiPassword: "5Ewy7GYAm55NxK62JJitDdf2"
  };

  const tokenBody = await callApi(
    "api/v2/token",
    "POST",
    body,
    "token",
    undefined,
    "https://clipping-api.sporttotal.tv/"
  );

  return tokenBody?.token;
};

export const clippingStatus = async (clipUuid: string) => {
  const token = await getToken();

  return callApi(
    "api/v2/ffmpeg/" + clipUuid,
    "GET",
    null,
    token,
    undefined,
    "https://clipping-api.sporttotal.tv/"
  );
};

export const clipping = async (clip: ClippingBody) => {
  const token = await getToken();
  const clipUuid = clip.uuid;
  const data = {
    source: clip.source,
    start: clip.start,
    duration: clip.duration,
    output: clip.output,
    callbackEndpoint: "string",
    watermark:
      "https://mam-uploads.azureedge.net/upload/adeel/image/6d282016-2934-427c-8716-fe344eb441cb/sporttotaltv-horizontal-white.png",
    watermarkPosition:
      "overlay=x=(main_w-overlay_w)/(main_w-overlay_w):y=(main_h-overlay_h)/(main_h-overlay_h)",
    videoUuid: clipUuid,
    concatSource: [
      {
        url: "",
        index: 1,
        videoUuid: clipUuid,
        height: 0,
        width: 0,
        framerate: 25
      },
      {
        url: "https://mam-uploads.azureedge.net/upload/adeel/video/d4295dda-3383-42f1-a2d6-fcb94b9f60d2/sporttotal-default-bumper-1080-25-fps.mp4",
        index: "0",
        videoUuid: `${clipUuid}_defaultBumper`,
        height: 0,
        width: 0,
        framerate: 25
      }
    ]
  };

  return callApi(
    "api/v2/clip",
    "POST",
    data,
    token,
    undefined,
    "https://clipping-api.sporttotal.tv/"
  );
};
